 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946","api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1":"api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1","api-doc-editor":"api-doc-editor","create-member":"create-member","login":"login","maint-board":"maint-board","member-list":"member-list","openapi-editor":"openapi-editor","player-list":"player-list","single-wallet-testing":"single-wallet-testing","tester-portal":"tester-portal","tssw":"tssw","update-bet-limit":"update-bet-limit","user-agent-list":"user-agent-list","user-list":"user-list","user-settings":"user-settings","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"api-doc~api-doc-v2~api-doc-v3~redoc-previewer","redoc-previewer":"redoc-previewer","not-found":"not-found","api-doc-v3":"api-doc-v3","enter-game":"enter-game","api-doc-v2":"api-doc-v2","api-doc":"api-doc","public-page":"public-page","Consolas-normal":"Consolas-normal","FZHTJW-normal":"FZHTJW-normal"}[chunkId]||chunkId) + "." + {"chunk-00740919":"5a4e80fe","api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"102a2ab5","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"22546aa5","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"cf457f7e","api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1":"a41360bc","api-doc-editor":"5f3f611c","create-member":"68eecde7","login":"88bfb5ed","maint-board":"6ce77d3f","member-list":"8a1fbf1e","openapi-editor":"c57da58f","player-list":"0371e802","single-wallet-testing":"86f3525d","tester-portal":"d4100199","tssw":"2b9c55de","update-bet-limit":"20ccf4ee","user-agent-list":"8b012853","user-list":"dbb73d2b","user-settings":"0de34a93","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"63a6dd3e","redoc-previewer":"e9f10b92","not-found":"470f4aac","api-doc-v3":"d655ebf5","enter-game":"9177a1a9","api-doc-v2":"7e720d7f","api-doc":"909b8633","public-page":"1fe5a202","Consolas-normal":"e321423a","FZHTJW-normal":"e8c011a7","chunk-2d216214":"7b2f8138","chunk-2d216257":"e4bfd80b","chunk-508e8328":"c363ee05"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":1,"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":1,"api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1":1,"api-doc-editor":1,"create-member":1,"login":1,"maint-board":1,"member-list":1,"openapi-editor":1,"player-list":1,"single-wallet-testing":1,"tester-portal":1,"tssw":1,"update-bet-limit":1,"user-agent-list":1,"user-list":1,"user-settings":1,"api-doc~api-doc-v2~api-doc-v3~redoc-previewer":1,"redoc-previewer":1,"not-found":1,"api-doc-v3":1,"enter-game":1,"api-doc-v2":1,"api-doc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946","api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1":"api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1","api-doc-editor":"api-doc-editor","create-member":"create-member","login":"login","maint-board":"maint-board","member-list":"member-list","openapi-editor":"openapi-editor","player-list":"player-list","single-wallet-testing":"single-wallet-testing","tester-portal":"tester-portal","tssw":"tssw","update-bet-limit":"update-bet-limit","user-agent-list":"user-agent-list","user-list":"user-list","user-settings":"user-settings","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"api-doc~api-doc-v2~api-doc-v3~redoc-previewer","redoc-previewer":"redoc-previewer","not-found":"not-found","api-doc-v3":"api-doc-v3","enter-game":"enter-game","api-doc-v2":"api-doc-v2","api-doc":"api-doc","public-page":"public-page","Consolas-normal":"Consolas-normal","FZHTJW-normal":"FZHTJW-normal"}[chunkId]||chunkId) + "." + {"chunk-00740919":"31d6cfe0","api-doc-editor~api-doc-v2~api-doc-v3~create-member~enter-game~login~maint-board~member-list~not-foun~a31d7ee8":"980cab4e","api-doc-editor~api-doc-v3~create-member~login~maint-board~member-list~openapi-editor~player-list~red~fa3f720c":"31d6cfe0","api-doc-editor~create-member~enter-game~login~maint-board~member-list~openapi-editor~player-list~red~7e416946":"dafe2577","api-doc-editor~create-member~login~maint-board~member-list~openapi-editor~player-list~single-wallet-~11ab9ad1":"9dfd6710","api-doc-editor":"aa0deb1c","create-member":"55786bdf","login":"143522c0","maint-board":"fa9035a3","member-list":"ee10e2c0","openapi-editor":"0fa575c5","player-list":"5514202a","single-wallet-testing":"07768efc","tester-portal":"c210d3a0","tssw":"df3c020b","update-bet-limit":"09ea6d4e","user-agent-list":"7d687e99","user-list":"3d91ab3d","user-settings":"726a3c02","api-doc~api-doc-v2~api-doc-v3~redoc-previewer":"8fdbf2f2","redoc-previewer":"8f42a752","not-found":"6a1866b3","api-doc-v3":"8bfcfd51","enter-game":"d7eedc0c","api-doc-v2":"ac6c80b2","api-doc":"ac6c80b2","public-page":"31d6cfe0","Consolas-normal":"31d6cfe0","FZHTJW-normal":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-508e8328":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
